export const getTileAttributes = () => [
  'moderne',
  'agile',
  'beton',
  'adaptatif',
  'clair',
  'abordable',
];

export const getLandingImages = (data) => {
  const getImageSrc = name => data[name].childImageSharp.responsiveResolution.src;
  const imageNames = [
    'banner',
    ...getTileAttributes(),
  ];

  return imageNames.reduce(
    (urls, imgName) => ({
      ...urls,
      [imgName]: getImageSrc(imgName),
    }),
    {},
  );
};



// WEBPACK FOOTER //
// ./src/pages/_utils.js